import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchProducts } from '../../services/shelf/actions';

import Spinner from '../Spinner';
import ShelfHeader from './ShelfHeader';
import ProductList from './ProductList';
import { changeFilter, resetSort, addToSort } from '../../services/carts/actions';
import Filter from '../Shelf/Filter';

import './style.scss';

class Shelf extends Component {
  static propTypes = {
    fetchProducts: PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    resetSort: PropTypes.func.isRequired,
    addToSort: PropTypes.func.isRequired,
    filters: PropTypes.string,
  };

  state = {
    isLoading: false
  };

  componentDidMount() {
    this.props.changeFilter(null);
    this.handleFetchProducts();
  }

  componentDidUpdate(prevProps){
    if( this.props.filters != prevProps.filters || this.props.selected != prevProps.selected  ){
      this.handleFetchProducts(this.props.filters);
    }
  }

  handleFetchProducts = (filters = null) => {
    this.setState({ isLoading: true });
    this.props.fetchProducts(this.props.addToSort, this.props.selected, this.props.availables, filters, () => {
      this.setState({ isLoading: false });
    });
  };

  render() {
    const { products } = this.props;
    const { isLoading } = this.state;

    return (
      <React.Fragment>
        {isLoading && <Spinner />}
        <>
          <Filter />
          <div className="shelf-container">
            <ShelfHeader productsLength={products.length} />
            <div className="d-flex flex-wrap justify-content-evenly">
              <ProductList products={products} />
            </div>
          </div>
        </>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  products: state.shelf.products,
  filters: state.carts.filter,
  availables: state.carts.sort.availables,
  selected: state.carts.sort.selected
});

export default connect(
  mapStateToProps,
  { fetchProducts, changeFilter, resetSort, addToSort }
)(Shelf);
